var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFullScreenIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3998 1.6001a.803.803 0 0 0-.7398.495c-.125.3-.055.6425.1725.8725l1.0348 1.0325-4.2317 4.235a.8013.8013 0 0 0 0 1.1325.801.801 0 0 0 1.1323 0l4.2316-4.235 1.0348 1.035c.23.23.5724.2975.8724.1725a.8.8 0 0 0 .4949-.74v-3.2c0-.4425-.3575-.8-.7999-.8zm-6.7986.8c-1.1048 0-1.9996.895-1.9996 2v8c0 1.105.8948 2 1.9996 2h7.9984c1.1048 0 1.9996-.895 1.9996-2v-2.8a.799.799 0 0 0-.7998-.8.799.799 0 0 0-.7999.8v2.8c0 .22-.1799.4-.3999.4H3.6012c-.22 0-.4-.18-.4-.4v-8c0-.22.18-.4.4-.4h2.7994a.799.799 0 0 0 .7999-.8.799.799 0 0 0-.7999-.8z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFullScreenIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/full-screen-icon.460771d28bbbfe99cbd9b9c1e88e8995.svg";